<div class="p-sub-column-layout01">
  <div class="p-sub-column-layout01__title p-sub-column-layout01__title--has-btn">
    <!--支払情報サマリタイトル -->
    <div class="p-heading-area01">
      <!--TODO: heading.mileageTax特典画面文言ID -->
      <h2
        class="p-heading-area01__title c-heading-2"
        [innerHTML]="isAwardBooking ? ('heading.mileageTax' | staticMsg) : ('heading.price2' | staticMsg)"
      ></h2>
    </div>
    <!--支払情報詳細モーダル表示 -->
    <button
      id="payment-amount-detail-button"
      class="c-btn-tertiary c-btn-tertiary--xs"
      (click)="this.clickPaymentDetails($event)"
    >
      <span class="c-btn-tertiary__text" [innerHTML]="'label.details2' | staticMsg"></span>
    </button>
  </div>
  <div class="p-sub-column-layout01__body">
    <div class="p-sub-column-layout01__item">
      <div class="p-sub-column-layout01__payment">
        <!-- 提携：有償の場合 -->
        <dl class="c-flex-list01" *ngIf="!isAwardBooking">
          <div class="c-flex-list01__item c-flex-list01__item--sb c-flex-list01__item--center">
            <!--支払い総額ラベルの表示-->
            <dt class="c-flex-list01__title">
              <div>
                <span
                  class="c-flex-list01__text-strong p-sub-column-layout01__text-total"
                  [innerHTML]="'label.totalAmount' | staticMsg"
                ></span>
              </div>
            </dt>
            <!--支払い総額-->
            <dd class="c-flex-list01__contents">
              <div class="c-flex-list01__contents-item">
                <span class="c-amount c-amount--price c-flex-list01__text-strong">
                  <span
                    class="c-amount__num c-amount__num--fs24"
                    [innerHTML]="this.totalPrice | amountFormat : undefined : this.totalPriceCurrency"
                  ></span>
                </span>
              </div>
              <div *ngIf="this.appliedDiscountType" class="c-flex-list01__contents-item">
                <span class="c-amount c-amount--price">
                  <span class="c-amount__num c-amount__num--fs20">
                    <del
                      [innerHTML]="this.totalPriceBeforeApplying | amountFormat : undefined : this.totalPriceCurrency"
                    ></del>
                  </span>
                </span>
              </div>
            </dd>
          </div>
        </dl>
        <!-- 提携：特典の場合-->
        <dl class="c-flex-list01" *ngIf="isAwardBooking">
          <div class="c-flex-list01__item c-flex-list01__item--sb c-flex-list01__item--center">
            <!--必要マイル数ラベルの表示 -->
            <dt class="c-flex-list01__title">
              <div>
                <span
                  class="c-flex-list01__text-strong p-sub-column-layout01__text-total"
                  [innerHTML]="'label.requiredMileage' | staticMsg"
                ></span>
              </div>
            </dt>
            <!--必要マイル数 -->
            <dd class="c-flex-list01__contents">
              <div class="c-flex-list01__contents-item">
                <span class="c-amount c-amount--price c-flex-list01__text-strong">
                  <span
                    class="c-amount__num c-amount__num--fs24"
                    [innerHTML]="this.pnrSumRequiredMiles | milesFormat : 'currencyUnit.MIL'"
                  ></span>
                </span>
              </div>
            </dd>
          </div>
          <div class="c-flex-list01__item c-flex-list01__item--sb c-flex-list01__item--center">
            <!--お支払合計ラベルの表示 -->
            <dt class="c-flex-list01__title">
              <div>
                <span
                  class="c-flex-list01__text-strong p-sub-column-layout01__text-total"
                  [innerHTML]="'label.paymentTotalAmount3' | staticMsg"
                ></span>
              </div>
            </dt>
            <!--お支払合計 -->
            <dd class="c-flex-list01__contents">
              <div class="c-flex-list01__contents-item">
                <span class="c-amount c-amount--price c-flex-list01__text-strong">
                  <span
                    class="c-amount__num c-amount__num--fs24"
                    [innerHTML]="this.totalTax | amountFormat : undefined : this.totalTaxCurrency"
                  ></span>
                </span>
              </div>
            </dd>
          </div>
        </dl>
      </div>
    </div>
    <div *ngIf="isPc && isDisplayPlanReviewLink" class="p-sub-column-layout01__item">
      <ul class="p-sub-column-layout01__list">
        <li class="p-sub-column-layout01__list-item">
          <a
            id="payment-amount-external_primary8"
            (throttleClick$)="clickPrevPlanInfo()"
            class="p-sub-column-layout01__list-link"
            [innerHTML]="'label.backToPlanConfirmation' | staticMsg"
            aswThrottleClick
          >
          </a>
        </li>
      </ul>
    </div>
  </div>
</div>
